import { render, staticRenderFns } from "./BxOrderForm.vue?vue&type=template&id=5ceb884f&"
import script from "./BxOrderForm.vue?vue&type=script&lang=js&"
export * from "./BxOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports